import { duration } from "jalali-moment";
import { omrehBaseClient } from "./client";

const DropDown = () => {
    return omrehBaseClient.get(
        'Package/DropDown'
    );
}
const CustomGetByKey = (id) => {
    return omrehBaseClient.get(
        'Package/CustomGetByKey',
        {
            params: {
                'Id': id
            }
        }
    );
}
const GetArabiaCityDropDown = () => {
    return omrehBaseClient.get('StaticVariables/GetArabiaCityDropDown');
}

const GetEventTypeDropDown = () => {
    return omrehBaseClient.get('StaticVariables/GetPackageDetailsEventTypeDropDown');
}

const CustomCreate = (data) => {
    return omrehBaseClient.post('Package/CustomCreate', {
        'name': data.name,
        'duration': data.duration,
        'isDefault': true,
        'details': data.details
    })
}

//edit package
const GetPackageFilter = (data) => {
    return omrehBaseClient.post('Package/GetPackageFilter',
        {

            "name": data.packageName,
            "paginationParam": {
                "orderBy": "CreateDate",
                "orderDescending": true,
                "pageNumber": 1,
                "pageSize": 10
            }
        }
    )
}
const GetPackageByID = (id) => {
    return omrehBaseClient.get('Package/GetById', {
        params: {
            'key': id
        }
    })
}
const EditPackage = (id, data) => {
    return omrehBaseClient.put('Package',
        {
            "name": data.name,
            "duration": data.duration
        }, {
        params: {
            'id': id
        }
    }
    )
}
const GetPackageDetailByPackageID = (id) => {
    return omrehBaseClient.get('PackageDetails/GetPackageDetailsByPackageID', {
        params: {
            'packageId': id
        }
    })
}
const EditPackageDetailtitle = (id, title) => {
    return omrehBaseClient.put('PackageDetails',
        {
            "title": title,

        }, {
        params: {
            'id': id
        }
    }
    )
}
const GetPackageEventsByPackageDetailID = (id) => {
    return omrehBaseClient.get('PackageDetailsEvent/GetPackageDetailsEventByPackageID', {
        params: {
            'packageDetailsId': id
        }
    })
}
const EditPackageEvent = (id, data) => {
    return omrehBaseClient.put('PackageDetailsEvent',
        {
            "description": data.description,
            "eventType": data.eventType,
            "fromCity": data.fromCity,
            "toCity": data.toCity,
            "startT": data.startT,
            "endT": data.endT,
            "isActive": true
        }, {
        params: {
            'id': id
        }
    }
    )
}
const DeactivePackageEvent = (id) => {
    return omrehBaseClient.put('PackageDetailsEvent/PackageDetailsEventActivate',
        {
            'isActive': false,

        }, {
        params: {
            'id': id,
        }
    }

    )
}



const packageApi = {
    CustomGetByKey, DropDown, GetArabiaCityDropDown, GetEventTypeDropDown, CustomCreate,
    GetPackageByID, GetPackageFilter, EditPackage, GetPackageDetailByPackageID, EditPackageDetailtitle,
    GetPackageEventsByPackageDetailID, EditPackageEvent, DeactivePackageEvent
}

export default packageApi